import React from 'react';
import { Link } from 'react-router-dom';
import { FaArrowRight } from 'react-icons/fa';

const ServiceCard = ({ service }) => {
  const {
    icon: Icon,
    title,
    description,
    link,
    tags = [],
    bgColor = '#DCE9FF', 
    textColorHover = '#4C5656'
  } = service;

  // Calculate lighter variant of bgColor for hover effects
  const bgColorLight = bgColor.replace(/^#/, '').replace(/../g, 
    color => ('0' + Math.min(255, Math.max(0, parseInt(color, 16) + 40)).toString(16)).substr(-2)
  );
  const boxShadowColor = bgColor + '7A'; // Add transparency

  const cardStyle = {
    '--bg-color': bgColor,
    '--bg-color-light': `#${bgColorLight}`,
    '--text-color-hover': textColorHover,
    '--box-shadow-color': boxShadowColor,
  };

  return (
    <Link 
      to={link || '#'} 
      className="zoho-service-card hover-card"
      style={cardStyle}
    >
      <div className="overlay"></div>
      
      <div className="zoho-service-header">
        <div className="zoho-service-icon-circle">
          <div className="circle">
            <div className="circle-inner">
              <Icon />
            </div>
          </div>
        </div>
      </div>

      <h3 className="zoho-service-title">{title}</h3>

      <p className="zoho-service-description">
        {description}
      </p>

      {tags.length > 0 && (
        <div className="zoho-service-tags">
          {tags.map((tag, index) => (
            <span key={index} className="zoho-service-tag">
              {tag}
            </span>
          ))}
        </div>
      )}

      {link && (
        <div className="zoho-service-link">
          Learn More
          <FaArrowRight className="zoho-service-link-icon" />
        </div>
      )}
    </Link>
  );
};

export default ServiceCard;